// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
// App Check removed; do not import firebase/app-check here

// Environment-based Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  // Optional: Add database URL if using Realtime Database
  ...(import.meta.env.VITE_FIREBASE_DATABASE_URL && {
    databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL
  })
};

// Validate that all required environment variables are present
const requiredEnvVars = [
  'VITE_FIREBASE_API_KEY',
  'VITE_FIREBASE_AUTH_DOMAIN', 
  'VITE_FIREBASE_PROJECT_ID',
  'VITE_FIREBASE_STORAGE_BUCKET',
  'VITE_FIREBASE_MESSAGING_SENDER_ID',
  'VITE_FIREBASE_APP_ID',
  'VITE_APP_SECRET_KEY',
  'VITE_FIREBASE_MEASUREMENT_ID',
  'VITE_FIREBASE_PROJECT_URL'
];

const missingVars = requiredEnvVars.filter(varName => !import.meta.env[varName]);
if (missingVars.length > 0) {
  throw new Error(`Missing required environment variables: ${missingVars.join(', ')}`);
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Configure auth to use long polling for better network compatibility
// This helps with proxies, VPNs, and restrictive networks
if (typeof window !== 'undefined') {
  auth.settings.appVerificationDisabledForTesting = false;
}

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

// Initialize Firestore with network-friendly settings
export const db = initializeFirestore(app, {
  // Auto-detects when to prefer long-polling (helps with proxies/VPNs)
  experimentalAutoDetectLongPolling: true,
  // Disable fetch streams to improve compatibility with certain proxies
  useFetchStreams: false,
  // Enable IndexedDB persistence with multi-tab synchronization
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  })
});

// Debug database connection

// Initialize Analytics (safe)
try {
  if (firebaseConfig.measurementId) {
    getAnalytics(app);
  }
} catch (e) {
  // Analytics init skipped
}

// App Check initialization removed per request — callables will be invoked without App Check tokens.

export default app;